//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"BendReliefDepth",0,"Expression",0],[0,"BendReliefType",1,0],[1,"BendReliefWidth",0,"Expression",0],[1,"EdgeChain",0,"ScCollector",0],[1,"FirstBendRadius",0,"Expression",0],[1,"FirstFlangeLength",0,"Expression",0],[0,"InsetType",1,0],[1,"MiterAngle",0,"Expression",0],[1,"NeutralFactor",0,"Expression",0],[1,"SecondBendRadius",0,"Expression",0],[1,"SecondFlangeLength",0,"Expression",0],[1,"SweepAngle",0,"Expression",0],[0,"Type",1,0],[0,"UseMiter",1,0]],[],[]];
SPLM.Features.SheetMetal.HemFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.HemFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.HemFlangeBuilder.InsetTypeOptions = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside"});

SPLM.Features.SheetMetal.HemFlangeBuilder.BendReliefOptions = Object.freeze({
    "Square" : "Square", "Round" : "Round", "None" : "None"});

SPLM.Features.SheetMetal.HemFlangeBuilder.TypeOptions = Object.freeze({
    "ClosedHemType" : "ClosedHemType", "OpenHemType" : "OpenHemType", "SFlangeHemType" : "SFlangeHemType", "CurlHemType" : "CurlHemType", "OpenLoopHemType" : "OpenLoopHemType", "ClosedLoopHemType" : "ClosedLoopHemType", "CenteredLoopHemType" : "CenteredLoopHemType"});

export default SPLM;